<template>
    <div class="activeApprove active">
      <van-cell-group class="group">
        <van-cell title="活动名称">
         <p class="item2"> 活动1</p>
        </van-cell>
        <van-cell title="活动日期">
          <p class="item2"> 2018-12-20  -  2019-04-30</p>
        </van-cell>
        <van-cell title="活动地点">
          <p class="item2"> 上海新天地</p>
        </van-cell>
        <van-cell title="邀请人数">
          <p class="item2"> 1000</p>
        </van-cell>
        <van-cell title="集客目标">
          <p class="item2"> 1000</p>
        </van-cell>
        <van-cell title="销售目标">
          <p class="item2"> 1000</p>
        </van-cell>
        <van-cell title="讲师姓名">
          <p class="item2"> 唐小西西</p>
        </van-cell>
        <van-cell title="合作伙伴">
          <p class="item2"> 唐小西西</p>
        </van-cell>
        <van-cell title="活动类型">
          <p class="item2"> 活动类型</p>
        </van-cell>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="活动主题"  />
          <div class="cell-content">
            这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动
          </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="group">
        <van-cell title="活动目的"  />
        <div class="cell-content">
          这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动
        </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="group">
        <van-cell title="讲师介绍"  />
        <div class="cell-content">
          这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动
        </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="group">
        <van-cell title="场地介绍"  />
        <div class="cell-content">
          这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动
        </div>
        </van-cell>
      </van-cell-group>

      <van-cell-group class="group group-table">
        <van-cell title="活动流程"  />
        </van-cell>

        <div class="table van-hairline--surround">
          <div class="table-title flex ">
            <p class="item1">序号</p>
            <p class="item2">日期</p>
            <p class="item2">时间</p>
            <p class="item3">内容</p>
          </div>
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">1</li>
            <li class="item2 van-hairline--right">2018.02.02</li>
            <li class="item2 van-hairline--right">09.00-09.30</li>
            <li class="item3 ">
              <p class="item1 content van-hairline--right">所有人员集合 并到前台签到发货就开始发哈手机号罚款是</p>
            </li>
          </ul>
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">1</li>
            <li class="item2 van-hairline--right">2018.02.02</li>
            <li class="item2 van-hairline--right">09.00-09.30</li>
            <li class="item3 ">
              <p class="item1 content van-hairline--right">所有人员集合 并到前台签到</p>
            </li>
          </ul>
        </div>
      </van-cell-group>

      <van-cell-group class="group group-table">
        <van-cell   >
          <template slot="title">
            <span class="custom-text">活动预算</span>
            <span class="mini-text">（未税8000，含税9000）</span>
          </template>
        </van-cell>
        <div class="table van-hairline--surround">
          <div class="table-title flex ">
            <p class="item1">序号</p>
            <p class="item2">名称</p>
            <p class="item1">数量</p>
            <p class="item3">未税费用</p>
            <p class="item3">含税费用</p>
          </div>
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">1</li>
            <li class="item2 van-hairline--right">场地费</li>
            <li class="item1 van-hairline--right">1</li>
            <p class="item3 van-hairline--right">2000</p>
            <li class="item3 flex">
              <p class="item1">3000</p>
            </li>
          </ul>
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">1</li>
            <li class="item2 van-hairline--right">场地费</li>
            <li class="item1 van-hairline--right">1</li>
            <p class="item3 van-hairline--right">2000</p>
            <li class="item3 flex">
              <p class="item1">3000</p>
            </li>
          </ul>
          <ul class="table-content flex van-hairline--top">
            <li class="item3 van-hairline--right">合计</li>
            <li class="item1 van-hairline--right"></li>
            <li class="item3 van-hairline--right"></li>
            <li class="item3"></li>
          </ul>
        </div>
      </van-cell-group>

      <van-cell-group class="group group-table">
        <van-cell   >
          <template slot="title">
            <span class="custom-text">物料申请</span>
          </template>
        </van-cell>
        <div class="table van-hairline--surround">
          <div class="table-title flex ">
            <p class="item1">序号</p>
            <p class="item3">产品一级分类</p>
            <p class="item2">产品名称</p>
            <p class="item1">数量</p>
            <p class="item3">归还日期</p>
          </div>
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">1</li>
            <li class="item3 van-hairline--right">甲类</li>
            <li class="item2 van-hairline--right">某某某</li>
            <li class="item1 van-hairline--right">20</li>
            <li class="item3 flex">
              <p class="item1">2019-02-28</p>
            </li>
          </ul>

        </div>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="图片"  />  </van-cell>
        <div class="flex">
          <p class="upload-img ">
            <img :src="require('@/assets/img/logo.png')" alt="">
          </p>
          <p class="upload-img ">
            <img :src="require('@/assets/img/logo.png')" alt="">
          </p>
        </div>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="审批记录"  />  </van-cell>
       <ul class="steps">
          <li class="step">
            <!--<van-icon name="clear" class="step-icon" color="#e83c39"  size="20px"/>-->
            <van-icon name="checked" class="step-icon"  color="#02c316"  size="20px"/>
            <!--<van-icon name="play-circle"  class="step-icon" color="#8bc34a"  size="20px"/>-->
            <div>
              <p class="flex">
                <span class="item1">2016-07-12 12:40</span>
                <span class="item1">唐小小</span>
              </p>
              <p>审批备注：同意</p>

            </div>
          </li>
         <li class="step">
           <van-icon name="clear" class="step-icon" color="#e83c39"  size="20px"/>
           <!--<van-icon name="checked" class="step-icon"  color="#02c316"  size="20px"/>-->
           <!--<van-icon name="play-circle"  class="step-icon" color="#8bc34a"  size="20px"/>-->
           <div>
             <p class="flex">
               <span class="item1">2016-07-12 12:40</span>
               <span class="item1">唐小小</span>
             </p>
             <p>审批备注：与实际不符</p>
             <p class="flex">
               <img :src="require('@/assets/img/logo.png')" class="step-img">
               <img :src="require('@/assets/img/logo.png')" class="step-img">
             </p>
           </div>
         </li>
         <li class="step">
           <!--<van-icon name="clear" class="step-icon" color="#e83c39"  size="20px"/>-->
           <!--<van-icon name="checked" class="step-icon"  color="#02c316"  size="20px"/>-->
           <van-icon name="play-circle"  class="step-icon" color="#8bc34a"  size="20px"/>
           <div>
             <p class="flex">
               <span class="item1">2016-07-12 12:40</span>
               <span class="item1">唐小小</span>
             </p>
             <p>提交备注：一周年吸粉活动</p>

           </div>
         </li>
       </ul>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="备注"  />  </van-cell>
        <van-field
          class="textarea van-hairline--surround"
          type="textarea"
          placeholder="请输入备注内容描述"
          rows="3"
          autosize
        />
        <div class="flex">
          <p class="upload-img ">
            <img :src="require('@/assets/img/logo.png')" alt="">
            <van-icon name="clear" class="del-icon" color="#e83c39"  size="20px"/>
          </p>
          <van-uploader :after-read="onRead" class="upload ">
            <van-icon name="plus" />
            <p>上传图片</p>
          </van-uploader>
        </div>
      </van-cell-group>

      <div class="bottom-btn flex">
        <div class="item1 btn save">拒绝</div>
        <div class="item1 btn sub" @click="sub">批准</div>
      </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        methods:{
          sub(){
             this.$router.push('/active/activeDetail')
          }
        }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../style/pageStyle/pageView-activeDetail.less";
  .van-cell__label{
    word-break:break-all;
  }
  .activeApprove{
    padding-bottom:55px;
  }
  .step-img{
    width:50px;
    height:50px;
    border-radius: 5px;
    margin:5px;
  }
  .steps{
    margin:10px 15px;
    .step{
      padding:10px 15px;
      border-left:1px solid #f2f2f2;
      position: relative;
      .step-icon{
        position: absolute;
        top:10px;
        left:-10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/active/activeApprove.vue